import React, { useEffect, useState } from "react";
import AppLogo from "../../assets/images/app-logo.jpg";

import "./MessengerChatWidget.css";
import { IconClose } from "../../assets/icons";

// Tăng version để "reset" và hiển thị lại cho toàn bộ user khi bạn cần
const POPUP_VERSION = "v1";
const LS_KEY = `messenger_popup_dismissed_${POPUP_VERSION}`;
const CK_KEY = `messenger_popup_dismissed_${POPUP_VERSION}`;

function getDismissed() {
  if (typeof window === "undefined") return false;
  try {
    if (localStorage.getItem(LS_KEY) === "1") return true;
  } catch {}
  try {
    return document.cookie.split("; ").some((c) => c.startsWith(`${CK_KEY}=1`));
  } catch {}
  return false;
}

function setDismissed(days = 365) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(LS_KEY, "1");
  } catch {}
  try {
    const expires = new Date(
      Date.now() + days * 24 * 60 * 60 * 1000
    ).toUTCString();
    document.cookie = `${CK_KEY}=1; path=/; expires=${expires}; SameSite=Lax`;
  } catch {}
}

const MessengerChatWidget = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  useEffect(() => {
    if (!getDismissed()) setIsPopupVisible(true);
  }, []);

  // Đồng bộ ẩn giữa nhiều tab
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === LS_KEY && e.newValue === "1") setIsPopupVisible(false);
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  // Close the popup when the close button is clicked
  const handleClosePopup = () => {
    setIsPopupVisible(false);
    setDismissed(2); // ẩn trong 2 ngày
  };

  return (
    <div className="chat-widget">
      {/* Popup message */}
      {isPopupVisible && (
        <div className="absolute right-0 bottom-[4rem] p-2 bg-white shadow-lg rounded-lg border border-gray-200 w-72">
          <div className="flex justify-between items-center">
            <div className="flex justify-start items-center gap-2">
              <img
                src={AppLogo}
                alt="Logo"
                className="w-8 h-8 object-contain"
              />

              <p className="text-md font-semibold text-gray-800 whitespace-nowrap text-nowrap">
                Hi! Bạn cần hỗ trợ gì ạ?
              </p>
            </div>
            <button
              onClick={handleClosePopup}
              className="text-gray-500 text-lg font-semibold hover:text-gray-700 rounded-full bg-gray-500/5 hover:bg-gray-500/50 p-1 "
            >
              <IconClose className="w-4 h-4 fill-black" />
            </button>
          </div>
          <div className="mt-3">
            <hr className="border-t border-gray-300" />
            <a
              href="https://m.me/lylyiphone"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center text-md text-blue-400 my-1 hover:text-blue-700"
            >
              Chat với Ly iPhone
            </a>
          </div>
        </div>
      )}

      {/* Messenger icon button */}
      <a
        href="https://m.me/lylyiphone"
        target="_blank"
        rel="noopener noreferrer"
        className="messenger-icon"
      >
        <img
          src={
            "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759421542/messenger-icon_okioea.png"
          }
          alt="Messenger"
        />
      </a>

      {/* Chat text info below icon */}
    </div>
  );
};

export default MessengerChatWidget;
